import { combineReducers } from 'redux'
import { authReducer } from './authReducer'
import { alertReducer } from './alertReducer'
import { loaderReducer } from './loaderReducer'
import { linksReducer } from './linkReducer'
import { LOG_OUT } from './../actionTypes'

const allReducers = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  loader: loaderReducer,
  links: linksReducer,
})

const rootReducer = (state, action) => {
  if (action.type === LOG_OUT) {
    const { auth } = state
    state = { auth }
  }
  return allReducers(state, action)
}
export default rootReducer
